module.exports = __webpack_public_path__ + "static/img/lightB.fe21d23e.png";